import React, { useEffect, useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const CategoryReport = ({ fromDate, toDate }) => {
  const { store } = useStateContext();

  const [data, setData] = useState();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
    const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

    const payload = {
      shopName: databaseStoreName,
      from: fromDate,
      to: toDate,
    };
    axiosClient
      .post("reports/sales/categories", payload)
      .then((response) => setData(response.data.data))
      .catch((err) => console.log(err));
  }, [store, fromDate, toDate]);

  if (!data) {
    return <div>Loading</div>;
  }

  const formatDate = (dateString) => {
    const parts = dateString.split('-');
    if (parts.length === 3) {
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    } else {
        return 'Invalid Date';
    }
}


  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="inherit">Category sales analysis</Typography>
        <Typography variant="caption">{` ${formatDate(fromDate)} - ${formatDate(toDate)}`}</Typography>
        <Divider />
      </Grid>
      <Grid item container xs={12}>
        <Grid item sm={4} md={4} xs={12}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Description</Typography>
        </Grid>
        <Grid item sm={3} md={3} xs={12}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Quantity</Typography>
        </Grid>
        <Grid item sm={3} md={3} xs={12}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Price</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      {data.map((category, index) => (
        <Grid item container xs={12} key={index+1}>
          <Grid item sm={4} md={4} xs={12}>
            <Typography variant="body2" align="center">{category.name}</Typography>
          </Grid>
          <Grid item sm={3} md={3} xs={12}>
            <Typography variant="body2" align="center">{category.totalQuantity}</Typography>
          </Grid>
          <Grid item sm={3} md={3} xs={12}>
            <Typography variant="body2" align="center">{parseFloat(category.totalPrice).toFixed(2)}</Typography>
          </Grid>
          <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default CategoryReport;
